/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DomainErrorDto,
  GetSupportCaseResponseDto,
  GetSupportCasesResponseDto
} from './pacApi.schemas';

import { axios } from '../../common/axios';
import type { ErrorType } from '../../common/axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const supportCasesControllerGetSupportCaseMessages = (
    supportCaseId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetSupportCaseResponseDto>(
      {url: `/api/v1/support-cases/${supportCaseId}`, method: 'GET', signal
    },
      options);
    }




export const getSupportCasesControllerGetSupportCaseMessagesQueryKey = (supportCaseId: string,) => {
    return [
    `/api/v1/support-cases/${supportCaseId}`
    ] as const;
    }


export const getSupportCasesControllerGetSupportCaseMessagesQueryOptions = <TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError = ErrorType<DomainErrorDto>>(supportCaseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportCasesControllerGetSupportCaseMessagesQueryKey(supportCaseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>> = ({ signal }) => supportCasesControllerGetSupportCaseMessages(supportCaseId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(supportCaseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportCasesControllerGetSupportCaseMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>>
export type SupportCasesControllerGetSupportCaseMessagesQueryError = ErrorType<DomainErrorDto>


export function useSupportCasesControllerGetSupportCaseMessages<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError = ErrorType<DomainErrorDto>>(
 supportCaseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>,
          TError,
          Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCasesControllerGetSupportCaseMessages<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError = ErrorType<DomainErrorDto>>(
 supportCaseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>,
          TError,
          Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCasesControllerGetSupportCaseMessages<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError = ErrorType<DomainErrorDto>>(
 supportCaseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportCasesControllerGetSupportCaseMessages<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError = ErrorType<DomainErrorDto>>(
 supportCaseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportCasesControllerGetSupportCaseMessagesQueryOptions(supportCaseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSupportCasesControllerGetSupportCaseMessagesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError = ErrorType<DomainErrorDto>>(supportCaseId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportCasesControllerGetSupportCaseMessagesQueryKey(supportCaseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>> = ({ signal }) => supportCasesControllerGetSupportCaseMessages(supportCaseId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportCasesControllerGetSupportCaseMessagesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>>
export type SupportCasesControllerGetSupportCaseMessagesSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSupportCasesControllerGetSupportCaseMessagesSuspense<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError = ErrorType<DomainErrorDto>>(
 supportCaseId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCasesControllerGetSupportCaseMessagesSuspense<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError = ErrorType<DomainErrorDto>>(
 supportCaseId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCasesControllerGetSupportCaseMessagesSuspense<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError = ErrorType<DomainErrorDto>>(
 supportCaseId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportCasesControllerGetSupportCaseMessagesSuspense<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError = ErrorType<DomainErrorDto>>(
 supportCaseId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCaseMessages>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportCasesControllerGetSupportCaseMessagesSuspenseQueryOptions(supportCaseId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const supportCasesControllerGetSupportCasesForWorkOrder = (
    workOrderId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetSupportCasesResponseDto>(
      {url: `/api/v1/support-cases/work-order/${workOrderId}`, method: 'GET', signal
    },
      options);
    }




export const getSupportCasesControllerGetSupportCasesForWorkOrderQueryKey = (workOrderId: string,) => {
    return [
    `/api/v1/support-cases/work-order/${workOrderId}`
    ] as const;
    }


export const getSupportCasesControllerGetSupportCasesForWorkOrderQueryOptions = <TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError = ErrorType<DomainErrorDto>>(workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportCasesControllerGetSupportCasesForWorkOrderQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>> = ({ signal }) => supportCasesControllerGetSupportCasesForWorkOrder(workOrderId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportCasesControllerGetSupportCasesForWorkOrderQueryResult = NonNullable<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>>
export type SupportCasesControllerGetSupportCasesForWorkOrderQueryError = ErrorType<DomainErrorDto>


export function useSupportCasesControllerGetSupportCasesForWorkOrder<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>,
          TError,
          Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCasesControllerGetSupportCasesForWorkOrder<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>,
          TError,
          Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCasesControllerGetSupportCasesForWorkOrder<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportCasesControllerGetSupportCasesForWorkOrder<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportCasesControllerGetSupportCasesForWorkOrderQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSupportCasesControllerGetSupportCasesForWorkOrderSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError = ErrorType<DomainErrorDto>>(workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportCasesControllerGetSupportCasesForWorkOrderQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>> = ({ signal }) => supportCasesControllerGetSupportCasesForWorkOrder(workOrderId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportCasesControllerGetSupportCasesForWorkOrderSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>>
export type SupportCasesControllerGetSupportCasesForWorkOrderSuspenseQueryError = ErrorType<DomainErrorDto>


export function useSupportCasesControllerGetSupportCasesForWorkOrderSuspense<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCasesControllerGetSupportCasesForWorkOrderSuspense<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCasesControllerGetSupportCasesForWorkOrderSuspense<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportCasesControllerGetSupportCasesForWorkOrderSuspense<TData = Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportCasesControllerGetSupportCasesForWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportCasesControllerGetSupportCasesForWorkOrderSuspenseQueryOptions(workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






